<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="progress()" [steps]="questions().length" class="block w-full" name="Vergelijken" />

  <rid-mechanic-content>
    <rid-mechanic-title title="Welke is het meest?" />

    <!-- options -->
    @for (input of [question()]; track input.id) {
      <div animate.leave="anim-fade-out" class="absolute flex flex-wrap items-center justify-center gap-4">
        @for (option of question().options; track $index) {
          <div [style.animation-delay.ms]="250 + $index * 100" animate.enter="anim-pop-in" data-test-id="answer-option">
            <rid-content-card
              (clicked)="choose($index)"
              [fullWidth]="true"
              [isClickable]="!isChecking()"
              [isClicked]="chosen() === $index"
              [state]="chosen() === $index ? (question().answer === $index ? 'CORRECT' : 'INCORRECT') : 'DEFAULT'"
              [text]="option"
            />
          </div>
        }
      </div>
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
